const UNUSABLE_FILE_STATUSES = ['failed', 'pending', 'uploading'];

export const isUsableFileNode = (node: { status?: string | null; [key: string]: any }) =>
  !UNUSABLE_FILE_STATUSES.includes(node.status ?? '');
